export const API_BASE_URL = process.env.NEXT_PUBLIC_API_URL ?? "http://localhost:8080";
export const QUERY_STALE_TIME_LIST = 30 * 1000;   // 30s
export const QUERY_STALE_TIME_DETAIL = 60 * 1000; // 60s
export const DEBOUNCE_MS = 300;
export const WEB_PUSH_PUBLIC_KEY = process.env.NEXT_PUBLIC_WEB_PUSH_PUBLIC_KEY ?? "";
